const JOBS_ADD = 'JOBS_ADD'
const JOBS_LOADING = 'JOBS_LOADING'
const JOBS_FETCH_ERROR = 'JOBS_FETCH_ERROR'
const MORE_JOBS = 'MORE_JOBS'
const CURRENT_FILTER = 'CURRENT_FILTER'
const CURRENT_JOB = 'CURRENT JOB'

export {
    JOBS_ADD,
    JOBS_LOADING,
    JOBS_FETCH_ERROR,
    MORE_JOBS,
    CURRENT_FILTER,
    CURRENT_JOB 
}